import { get, pick, pickBy, omit, map, mapKeys, mapValues, filter, orderBy } from 'lodash-es';

class Transformer {
  value: any;

  constructor(value: any) {
    this.value = value;
  }

  apply = (func: Function, ...args: any[]) => new Transformer(this.value && func(this.value, ...args));
  transform = (func: Function, ...args: any[]) => this.apply(func, ...args);
  get = (...args: any[]) => this.apply(get, ...args);
  pick = (...args: any[]) => this.apply(pick, ...args);
  pickBy = (...args: any[]) => this.apply(pickBy, ...args);
  omit = (...args: any[]) => this.apply(omit, ...args);
  map = (...args: any[]) => this.apply(map, ...args);
  mapKeys = (...args: any[]) => this.apply(mapKeys, ...args);
  mapValues = (...args: any[]) => this.apply(mapValues, ...args);
  filter = (...args: any[]) => this.apply(filter, ...args);
  orderBy = (...args: any[]) => this.apply(orderBy, ...args);
}

const createTransformer = (value: any) => new Transformer(value);

export default createTransformer;
